import t from 'tcomb';
import UUID from './UUID';
import URL from './URL';

const Like_Component = t.struct({
  id: UUID,
  url: URL
}, 'Like_Component');

Like_Component.prototype.to_form = function(opts) {
  t.assert(t.Str.is(opts.like_url));
  return {
    type: 'reducer/like',
    id: this.id,
    url: this.url,
    like_url: opts.like_url
  };
};

export default Like_Component;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Like_Component.js
 **/